// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Merriweather", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden !important;
  background-color: #FBFBFD  !important;
}

/* Add globally */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}


code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

button,
input[type="button"],
input[type="submit"],
input[type="reset"],
.btn {
  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;
  cursor: pointer;
}

button:active:not(.student-hero__scroll):not(.home-schedule-arrow),
input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active,
.btn:active:not(.home-schedule-arrow) {
  transform: scale(0.97);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
}

button:focus-visible,
input[type="button"]:focus-visible,
input[type="submit"]:focus-visible,
input[type="reset"]:focus-visible,
.btn:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
}

.form-check {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  padding-left: 0 !important;
  min-height: auto;
}

/*
  Shared checkbox look (Add Course dialog pattern).
  Skip attendance Present/Absent switches (role=switch / .att-switch).
*/
.form-check-input,
input[type="checkbox"]:not([role="switch"]) {
  float: none;
  width: 1.15em !important;
  height: 1.15em !important;
  margin-top: 0.2em;
  margin-left: 0 !important;
  flex-shrink: 0;
  position: static;
  cursor: pointer;
  accent-color: #d5d1fd;
}

.form-check .form-check-input {
  float: none;
  position: static;
}

.att-switch input[type="checkbox"] {
  /* Keep switch affordance: visually hidden native control */
  position: absolute !important;
  opacity: 0 !important;
  width: 1px !important;
  height: 1px !important;
  margin: 0 !important;
  pointer-events: none;
}

.form-check-label {
  cursor: pointer;
}

.d-flex.flex-column.gap-2 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}


.row{
  margin-right: 0 !important;
  margin-left: 0 !important;
}

@keyframes blinkLightDark {
  0%, 100% {
    color: #000000; /* Dark */
  }
  50% {
    color: #d5d1fd; /* Light */
  }
}

/* Custom table borders for clearer separation */
.custom-table th,
.custom-table td {
  border: 1px solid rgb(0, 0, 0, 0.3);
}

.custom-table thead th {
  border: none;
}

.blink-text {
  animation: blinkLightDark 2.0s infinite;
  font-size: 42px;
  text-align: center;
}


.raise-on-hover {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.raise-on-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE;aACW;AACb;;AAEA;;;;;EAKE,0EAA0E;EAC1E,eAAe;AACjB;;AAEA;;;;;EAKE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;;;;;EAKE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;CAGC;AACD;;EAEE,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc,EAAE,SAAS;EAC3B;EACA;IACE,cAAc,EAAE,UAAU;EAC5B;AACF;;AAEA,gDAAgD;AAChD;;EAEE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Merriweather\", serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden !important;\n  background-color: #FBFBFD  !important;\n}\n\n/* Add globally */\n::-webkit-scrollbar {\n  width: 6px;\n}\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n}\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nbutton,\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"],\n.btn {\n  transition: transform 0.12s ease, box-shadow 0.12s ease, filter 0.12s ease;\n  cursor: pointer;\n}\n\nbutton:active:not(.student-hero__scroll):not(.home-schedule-arrow),\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active,\n.btn:active:not(.home-schedule-arrow) {\n  transform: scale(0.97);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);\n}\n\nbutton:focus-visible,\ninput[type=\"button\"]:focus-visible,\ninput[type=\"submit\"]:focus-visible,\ninput[type=\"reset\"]:focus-visible,\n.btn:focus-visible {\n  outline: 2px solid rgba(37, 99, 235, 0.35);\n  outline-offset: 2px;\n}\n\n.form-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  padding-left: 0 !important;\n  min-height: auto;\n}\n\n/*\n  Shared checkbox look (Add Course dialog pattern).\n  Skip attendance Present/Absent switches (role=switch / .att-switch).\n*/\n.form-check-input,\ninput[type=\"checkbox\"]:not([role=\"switch\"]) {\n  float: none;\n  width: 1.15em !important;\n  height: 1.15em !important;\n  margin-top: 0.2em;\n  margin-left: 0 !important;\n  flex-shrink: 0;\n  position: static;\n  cursor: pointer;\n  accent-color: #d5d1fd;\n}\n\n.form-check .form-check-input {\n  float: none;\n  position: static;\n}\n\n.att-switch input[type=\"checkbox\"] {\n  /* Keep switch affordance: visually hidden native control */\n  position: absolute !important;\n  opacity: 0 !important;\n  width: 1px !important;\n  height: 1px !important;\n  margin: 0 !important;\n  pointer-events: none;\n}\n\n.form-check-label {\n  cursor: pointer;\n}\n\n.d-flex.flex-column.gap-2 {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n\n.row{\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n@keyframes blinkLightDark {\n  0%, 100% {\n    color: #000000; /* Dark */\n  }\n  50% {\n    color: #d5d1fd; /* Light */\n  }\n}\n\n/* Custom table borders for clearer separation */\n.custom-table th,\n.custom-table td {\n  border: 1px solid rgb(0, 0, 0, 0.3);\n}\n\n.custom-table thead th {\n  border: none;\n}\n\n.blink-text {\n  animation: blinkLightDark 2.0s infinite;\n  font-size: 42px;\n  text-align: center;\n}\n\n\n.raise-on-hover {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.raise-on-hover:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
